import type { PageConfig } from "@/modules/routing/types"

import routingConfig from "@root/routing-config.json"

/**
 * In the case we don't get the x-page-type header from the frontend-gateway, we
 * check in the routing-config.json.
 */
export const getServerPageTypeFromUrl = (url: URL | string): string | null => {
  const pathToProcess = typeof url === "string" ? new URL(url).pathname : url.pathname

  const pageConfig = (routingConfig as PageConfig[]).find(config =>
    config.paths.some(path => new RegExp(path).test(pathToProcess))
  )

  if (!pageConfig) {
    return null
  }

  return pageConfig.page_type
}
